import { useTranslation } from 'hooks/useTypedTranslation';
import { addToast } from 'modules/toast/stores/actions';

import { logout } from '../actions/logout';

export const useLogout = () => {
  const { t } = useTranslation('common');

  return () => {
    const onLogoutFailed = () => {
      addToast({
        title: t('Logout failed')!,
        description: t('Please try again')!,
        type: 'error'
      });
    };
    return logout({ onFailed: onLogoutFailed });
  };
};
